import { Controller, useFieldArray } from "react-hook-form";
import { Row, Col, Form } from "react-bootstrap";
import Select from "react-select";
import ProductSection from "./ThirdVarient";
import { useEffect, useState } from "react";
import { getData } from "../../../utils/api";
import { Select2Data, variant_type } from "../../../utils/common";

const DoubleVarient = ({
  clearErrors,
  useWatch,
  setError,
  singleIndex,
  control,
  register,
  getValues,
  errors,
  setValue,
  variantType,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: `variants.${singleIndex}.double_variants`,
  });

  const [Sizes, setSize] = useState([]);
  const getAllSize = async () => {
    const response = await getData(`/common/masters/all-size`);
    if (response?.success) {
      setSize(await Select2Data(response?.data, "size_id"));
    }
  };

  useEffect(() => {
    getAllSize();
  }, []);

  

  const [variantsError, setVariantsError] = useState("");

  useEffect(() => {
    register(`variants.${singleIndex}.double_variants`, {
      validate: (value) => {
        const isValid = value && value.length > 0;
        setVariantsError(isValid ? "" : "At least one size is required");
        return isValid;
      },
    });
  }, [register]);
  return (
    <>
      {variantsError && <span className="text-danger">{variantsError}</span>}
      {fields.map((delivery, deliveryIndex) => (
        <div key={delivery.id} className="border p-3 mb-3">
          <Row className="mb-3">
            <h5>Size {deliveryIndex + 1}</h5>

            <Col md={4}>
              <Form.Group>
                <Form.Label>Size</Form.Label>
                <Controller
                  control={control}
                  name={`variants.${singleIndex}.double_variants.${deliveryIndex}.size_id`}
                  rules={{
                    required: "Select Size",
                  }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={Sizes}
                      onChange={(selectedOption) => {
                        field.onChange(selectedOption.value);
                        setValue(
                          `variants.${singleIndex}.double_variants.${deliveryIndex}.size_id`,
                          selectedOption,
                        );
                      }}
                    />
                  )}
                />

                {errors?.variants?.[singleIndex]?.double_variants?.[
                  deliveryIndex
                ]?.size_id && (
                  <span className="text-danger">
                    {
                      errors.variants[singleIndex].double_variants[
                        deliveryIndex
                      ].size_id.message
                    }
                  </span>
                )}
              </Form.Group>
            </Col>
            {Number(variantType?.value) === Number(variant_type.Double) && (
              <>
                {" "}
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>MRP</Form.Label>
                    <Form.Control
                      type="text"
                      {...register(
                        `variants.${singleIndex}.double_variants.${deliveryIndex}.mrp`,
                        {
                          required: "MRP required",
                        },
                      )}
                      onKeyDown={(e) => {
                        // Allow numbers, backspace, left arrow, right arrow, and a decimal point
                        if (
                          !/[0-9]/.test(e.key) && // Disallow any non-numeric key
                          e.key !== "Backspace" &&
                          e.key !== "ArrowLeft" &&
                          e.key !== "ArrowRight" &&
                          e.key !== "."
                        ) {
                          e.preventDefault(); // Prevent the event if it's not allowed
                        }

                        // Prevent entering more than one decimal point
                        if (e.key === "." && e.target.value.includes(".")) {
                          e.preventDefault();
                        }
                      }}
                    />
                    {errors?.variants?.[singleIndex]?.double_variants?.[
                      deliveryIndex
                    ]?.mrp && (
                      <span className="text-danger">
                        {
                          errors.variants[singleIndex].double_variants[
                            deliveryIndex
                          ].mrp.message
                        }
                      </span>
                    )}
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Price</Form.Label>
                    <Form.Control
                      type="text"
                      {...register(
                        `variants.${singleIndex}.double_variants.${deliveryIndex}.price`,
                        {
                          required: "Price required",
                          validate: (value) => {
                            const mrp = getValues(
                              `variants.${singleIndex}.double_variants.${deliveryIndex}.mrp`,
                            );

                            if (mrp && Number(value) > Number(mrp)) {
                              return "Price cannot be greater than MRP";
                            }
                            return true;
                          },
                        },
                      )}
                      onKeyDown={(e) => {
                        // Allow numbers, backspace, left arrow, right arrow, and a decimal point
                        if (
                          !/[0-9]/.test(e.key) && // Disallow any non-numeric key
                          e.key !== "Backspace" &&
                          e.key !== "ArrowLeft" &&
                          e.key !== "ArrowRight" &&
                          e.key !== "."
                        ) {
                          e.preventDefault(); // Prevent the event if it's not allowed
                        }

                        // Prevent entering more than one decimal point
                        if (e.key === "." && e.target.value.includes(".")) {
                          e.preventDefault();
                        }
                      }}
                    />
                    {errors?.variants?.[singleIndex]?.double_variants?.[
                      deliveryIndex
                    ]?.price && (
                      <span className="text-danger">
                        {
                          errors.variants[singleIndex].double_variants[
                            deliveryIndex
                          ].price.message
                        }
                      </span>
                    )}
                  </Form.Group>
                </Col>
              </>
            )}
          </Row>
          {Number(variantType?.value) === Number(variant_type.Triple) && (
            <ProductSection
              useWatch={useWatch}
              clearErrors={clearErrors}
              setError={setError}
              singleIndex={singleIndex}
              deliveryIndex={deliveryIndex}
              control={control}
              register={register}
              getValues={getValues}
              errors={errors}
              setValue={setValue}
            />
          )}

          <button
            type="button"
            className="btn btn-danger "
            onClick={() => remove(deliveryIndex)}
          >
            Remove Size
          </button>
        </div>
      ))}

      <div className="text-center">
        <button
          type="button"
          className="btn btn-secondary me-2 w-auto"
          onClick={() => append({ triple_variants: [] })}
        >
          + Add Size
        </button>
      </div>
    </>
  );
};

export default DoubleVarient;
